import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import CategoryNav from "./components/CategoryNav";
import FeedList from "./components/FeedList";
import HotRead from "./components/HotRead";
import SubmitZone from "./components/SubmitZone";
import FaqZone from "./components/FaqZone";
import AboutStrip from "./components/AboutStrip";
import Footer from "./components/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "爆瓜网 - 用户投稿上传爆料 网友互动评论留言专区";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "爆瓜网开放用户投稿与互动，上传爆料直达专区，网友评论留言实时讨论。你的线索可能就是下一个大瓜，与千万吃瓜群众一起参与话题，共享爆料乐趣。");
  }, []);

  return (
    <div className="min-h-screen bg-[#fbf7ef]">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <CategoryNav />
        <FeedList />
        <HotRead />
        <SubmitZone />
        <FaqZone />
        <AboutStrip />
      </main>
      <Footer />
    </div>
  );
}